import React from 'react';
import type { ChangeEvent } from 'react';
import type { TravelerFormValues } from '../../../../api/reservationInfo';
import type { TravelerFieldRules } from '../utils';

type Props = {
  travelerFieldRules: TravelerFieldRules;
  traveler: TravelerFormValues;
  onSelectChange: (field: keyof TravelerFormValues) => (e: ChangeEvent<HTMLSelectElement>) => void;
  disabled: boolean;
};

const ReservationInfoAirSeatField = ({ travelerFieldRules, traveler, onSelectChange, disabled }: Props) => {
  const { isRequired, isVisible } = travelerFieldRules;
  if (!isVisible('air_seat')) return null;
  const styles = getStyles();

  return (
    <div style={styles.formGroup}>
      <label htmlFor="traveler-airSeat" style={styles.label}>
        座席の希望
        {isRequired('air_seat') && <span style={styles.required}>*</span>}
      </label>
      <select
        id="traveler-airSeat"
        style={styles.select}
        value={traveler.airSeat}
        onChange={onSelectChange('airSeat')}
        disabled={disabled}
      >
        <option value="">希望なし</option>
        <option value="window">窓側</option>
        <option value="aisle">通路側</option>
      </select>
    </div>
  );
};

const getStyles = (): Record<string, React.CSSProperties> => ({
  formGroup: {
    marginBottom: '16px'
  },
  label: {
    display: 'block',
    fontSize: '14px',
    fontWeight: 500,
    marginBottom: '6px',
    color: '#333'
  },
  required: {
    color: '#e74c3c',
    marginLeft: '4px'
  },
  input: {
    width: '100%',
    padding: '10px 12px',
    fontSize: '14px',
    border: '1px solid #ccc',
    borderRadius: '4px',
    boxSizing: 'border-box' as const,
    outline: 'none'
  },
  select: {
    width: '100%',
    padding: '10px 12px',
    fontSize: '14px',
    border: '1px solid #ccc',
    borderRadius: '4px',
    boxSizing: 'border-box' as const,
    outline: 'none',
    backgroundColor: '#fff',
    cursor: 'pointer'
  },
  inputError: {
    borderColor: '#e74c3c'
  },
  errorText: {
    color: '#e74c3c',
    fontSize: '12px',
    marginTop: '4px',
    display: 'block'
  }
});

export default ReservationInfoAirSeatField;
